var map = {
	"./de.ts": [
		47924,
		767
	],
	"./es.ts": [
		95571,
		786
	],
	"./fr.ts": [
		81691,
		786
	],
	"./pt.ts": [
		40775,
		767
	],
	"./zh-Hans.ts": [
		28566,
		767
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 39311;
module.exports = webpackAsyncContext;